import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../TestCard/TestCard.css';

interface PostCardProps {
    id: string;
    title: string;
    description: string;
    readTime: string;
}

const PostCard: React.FC<PostCardProps> = ({ id, title, description, readTime }) => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate(`/materials/article/${id}`);
    };

    return (
        <div className="test-card" onClick={handleClick}>
            <div className="test-card-content">
                <h3 className="test-card-title">{title}</h3>
                <p className="test-card-description">{description}</p>
                <div className="test-card-footer">
                    <span className="test-card-duration">📖 {readTime}</span>
                    <button className="test-card-button">Читать</button>
                </div>
            </div>
        </div>
    );
};

export default PostCard;
